import { ComponentsSettings } from './settings'

const fixComponentSettingsFn = (componentSettings: ComponentsSettings) => {
  const keys = Object.keys(componentSettings)
  return keys.reduce((acc, key) => {
    const subProduct = componentSettings[key]
    if (subProduct.filterBar) {
      return {
        ...acc,
        [key]: {
          ...subProduct,
          filterBar: {
            ...subProduct.filterBar,
            scopes: subProduct.filterBar?.scopes?.filter(scope => Boolean(scope.id)),
          },
        },
      }
    }

    return {
      ...acc,
      [key]: subProduct,
    }
  }, {})
}

export default fixComponentSettingsFn
